import { render, staticRenderFns } from "./YearGallery.vue?vue&type=template&id=56ea1aa6&scoped=true&"
import script from "./YearGallery.vue?vue&type=script&lang=js&"
export * from "./YearGallery.vue?vue&type=script&lang=js&"
import style0 from "./YearGallery.vue?vue&type=style&index=0&id=56ea1aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea1aa6",
  null
  
)

export default component.exports